import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query FlowUpstreamFlowsFilteredByFlowOutputFieldWithoutPersonalSpaceQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: FlowSortOrder!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
